import { render, staticRenderFns } from "./Uploadimage.vue?vue&type=template&id=0bf8f8f0&"
import script from "./Uploadimage.vue?vue&type=script&lang=js&"
export * from "./Uploadimage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports